@for (image of images$ | async; track trackByFn($index, image)) {
  <div
    class="container"
    [ngClass]="{ revealed: !!image.thumbUrl && !!image.fullUrl }"
    (click)="onImageSelected(image)">
    @if (!(image.fullUrl || image.thumbUrl)) {
      <img
        class="placeholder"
        src="/assets/imgs/image-loading-placeholder.svg" />
    }
    @if (image.fullUrl) {
      <img class="cover" [ngClass]="fullImageClass(image)" [src]="sanitizeUrl(image.fullUrl)" />
    }
    @if (image.thumbUrl) {
      <img class="cover overlay" [src]="sanitizeUrl(image.thumbUrl)" />
    }
  </div>
}
